import React from 'react';

import {FullHTMLLink} from 'app/components/general/FullHTMLLink';
export type Props = {
  item: any;
  nameProcessor: (arg0: any) => JSX.Element;
};

const DashboardSidebarCollapsableListItem = ({item, nameProcessor}: Props) => (
  <li>
    <FullHTMLLink html_url={item.html_url}>{nameProcessor(item)}</FullHTMLLink>
  </li>
);

export default DashboardSidebarCollapsableListItem;
